import { Menu } from '@headlessui/react'
import { useCreatePaymentMethodCountryConnection } from 'hooks/usePaymentMethodApi'
import { mapFavritAppToName } from 'utils/favritAppUtils'
import { FavritApp, PaymentMethodCountryConnectionDto } from '../../generated-api'
import Chip from './Chip'

type AddFavritAppToCountryMenuProps = {
    countryConnection: PaymentMethodCountryConnectionDto
    buttonElement: React.ReactNode
}

const AddFavritAppToCountryMenu = (props: AddFavritAppToCountryMenuProps) => {
    const { countryConnection, buttonElement } = props

    const { mutate: runCreateCountryConnection } = useCreatePaymentMethodCountryConnection(
        countryConnection.paymentProvider,
        countryConnection.paymentMethod,
        countryConnection.countryCode
    )

    const handleAddApp = (favritApp: FavritApp) => {
        const updatedApps = new Set(countryConnection.defaultEnabledInApps)
        updatedApps.add(favritApp)

        runCreateCountryConnection({
            paymentsEnabled: countryConnection.paymentsEnabled,
            defaultEnabledInApps: updatedApps,
        })
    }

    const availableApps = Object.values(FavritApp).filter((x) => !countryConnection.defaultEnabledInApps.has(x))

    return (
        <>
            <Menu as="div" className="relative inline-block text-left">
                <Menu.Button>{buttonElement}</Menu.Button>
                <Menu.Items className="absolute left-0 z-10 mt-2 w-[200px] bg-brand-white border border-[#e2e8f0] divide-y divide-[#e2e8f0] cursor-pointer">
                    {availableApps.map((availableApp) => (
                        <Menu.Item key={`add-app-menu-${availableApp}`}>
                            {({ active }) => (
                                <div
                                    onClick={() => handleAddApp(availableApp)}
                                    className={`flex text-brand-primary px-3 py-4 ${
                                        active ? 'bg-purple-lightest' : ''
                                    }`}
                                >
                                    <Chip size="medium" text={mapFavritAppToName(availableApp)} />
                                </div>
                            )}
                        </Menu.Item>
                    ))}
                </Menu.Items>
            </Menu>
        </>
    )
}

export default AddFavritAppToCountryMenu
